export default {
    content: {
        class: [''],
    },
    listContainer: {
        class: ['select-list-container'],
    },
    option: {
        class: ['select-option'],
    },
    // The tab stop is the label, a span that ends where the chevron starts, so the floor's
    // ring round it is a box cut inside the field. The field is a field shell instead
    // (packages/design-system/DESIGN.md, "The field shell"): the label stands aside
    // through the floor's opt-out (`data-focus-ring`, censused in
    // packages/design-system/__tests__/focus-census.repo.test.ts) and the root takes the
    // one ring, the floor's own figure, on the box the reader sees. `focus:outline-none`
    // on `.select-label` answers the browser's own ring once the floor stands aside.
    label: {
        class: ['select-label'],
        'data-focus-ring': 'none',
    },

    root: ({ props, context, parent }) => ({
        class: [
            'select-root',
            'pb-field-shell',

            {
                'pselect-disabled': props.disabled,
            },
        ],
    }),
};
